exports = module.exports = require("../../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".margin-left-2[data-v-8d1ef93e]{margin-left:4px}.margin-left-2[data-v-8d1ef93e]:first-child{margin-left:0}", ""]);

// exports
